import 'antd/dist/reset.css'
import * as React from 'react'
import MapProvider from 'src/context/MapContext'
import UserProvider from 'src/context/UserContext'
import { Main } from './Main'
import './style.css'

export const Root: React.FC = () =>
(
    <UserProvider>
        <MapProvider>
            <Main />
        </MapProvider>
    </UserProvider>
)


// WEBPACK FOOTER //
// ./src/component/root/Root.tsx